const PENDING_BANKID_RETURN_KEY = "bilenia.pendingBankIdReturn";
const PENDING_BANKID_RETURN_AT_KEY = "bilenia.pendingBankIdReturnAt";
/** Survive Android process death after BankID Custom Tabs (sessionStorage is wiped). */
const PENDING_TTL_MS = 5 * 60 * 1000;

function isFresh(storedAt: string | null): boolean {
  if (!storedAt) return false;
  const ts = Number(storedAt);
  if (!Number.isFinite(ts)) return false;
  return Date.now() - ts < PENDING_TTL_MS;
}

/** Persist BankID return query so cold-start bootstrap cannot wipe it. */
export function stashPendingBankIdReturn(search: string): void {
  try {
    const normalized = search.startsWith("?") ? search : search ? `?${search}` : "";
    if (!normalized || normalized === "?") return;
    localStorage.setItem(PENDING_BANKID_RETURN_KEY, normalized);
    localStorage.setItem(PENDING_BANKID_RETURN_AT_KEY, String(Date.now()));
    // Keep sessionStorage mirror for same-process warm returns.
    sessionStorage.setItem(PENDING_BANKID_RETURN_KEY, normalized);
  } catch {
    /* ignore */
  }
}

export function takePendingBankIdReturn(): string | null {
  try {
    const fromSession = sessionStorage.getItem(PENDING_BANKID_RETURN_KEY);
    if (fromSession) {
      sessionStorage.removeItem(PENDING_BANKID_RETURN_KEY);
      localStorage.removeItem(PENDING_BANKID_RETURN_KEY);
      localStorage.removeItem(PENDING_BANKID_RETURN_AT_KEY);
      return fromSession;
    }

    const fromLocal = localStorage.getItem(PENDING_BANKID_RETURN_KEY);
    const at = localStorage.getItem(PENDING_BANKID_RETURN_AT_KEY);
    localStorage.removeItem(PENDING_BANKID_RETURN_KEY);
    localStorage.removeItem(PENDING_BANKID_RETURN_AT_KEY);
    if (!fromLocal || !isFresh(at)) return null;
    return fromLocal;
  } catch {
    return null;
  }
}

export function peekPendingBankIdReturn(): string | null {
  try {
    const fromSession = sessionStorage.getItem(PENDING_BANKID_RETURN_KEY);
    if (fromSession) return fromSession;

    const fromLocal = localStorage.getItem(PENDING_BANKID_RETURN_KEY);
    const at = localStorage.getItem(PENDING_BANKID_RETURN_AT_KEY);
    if (!fromLocal || !isFresh(at)) return null;
    return fromLocal;
  } catch {
    return null;
  }
}
